import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { useReactToPrint } from 'react-to-print';
import io from 'socket.io-client'; 
import {API_URL} from "../../utils/apiConfig";
import { Box, Button, Heading, Spinner, Table, Th, Thead, Tbody, Tr, Td, Text, Img } from '@chakra-ui/react';
import PH from "../../Images/PH.png";
import FX from "../../Images/FX.png";
import HB from "../../Images/HB.png";
import PB from "../../Images/PB.png";
import SR from "../../Images/SR.png";
import VT from "../../Images/VT.png";
import BB from "../../Images/BB.png";
import UB from "../../Images/UB.png";

const VaultFinal = () => {
  const { eventId } = useParams();
  const { user, loading: userLoading } = useAuth();
  const [event, setEvent] = useState(null);
  const [allPlayers, setAllPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const componentPDF = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!userLoading) {

      fetchAllPlayers();
    }
  }, [userLoading, user, eventId, navigate]);

  const fetchAllPlayers = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/events/${eventId}`);
      const eventDetails = response.data;
      setEvent(eventDetails);
      console.log("AllAroundEventDetails", eventDetails);

      if (eventDetails && eventDetails.players && eventDetails.sports) {
        const vaultEvents = ['vault1Men', 'vault2Men', 'vault1Women', 'vault2Women'];
const enabledGames = Object.keys(eventDetails.sports)
    .filter(game => eventDetails.sports[game] && vaultEvents.includes(game));
        const aggregatedPlayers = {};

        enabledGames.forEach((game) => {
          const gamePlayers = eventDetails.players[game];
          console.log("AllAroundGamePlayers", gamePlayers);

          if (gamePlayers) {
            gamePlayers.forEach(player => {
              const uniqueId = player.email || player.mobile;

              if (!aggregatedPlayers[uniqueId]) {
                aggregatedPlayers[uniqueId] = {
                  name: player.name,
                  email: player.email,
                  athleteCode: player.athleteCode,
                  scores: {},
                  totalAllAround: 0,
                  teamName: 'N/A',
                };

                // Check if player is in any team
              let teamFound = false;

                Object.keys(eventDetails.teams || {}).forEach((team) => {
                const teamMembers = eventDetails.teams[team].gymnasts || [];
                const match = teamMembers.some((member) => 
                  (member.email && member.email === player.email) || 
                  (member.mobile && member.mobile === player.mobile)
                );
                if (match) {
                  aggregatedPlayers[uniqueId].teamName = team;
                  teamFound = true;
                }
              });

              // If no team found, use player.city as teamName
              if (!teamFound) {
                aggregatedPlayers[uniqueId].teamName = player.city || 'N/A';
                console.log(`Player ${player.name} not found in any team. Using city as team name.`);
              }
  
              if (!teamFound) {
                console.log(`Player ${player.name} not found in any team.`);
              }
            }

              aggregatedPlayers[uniqueId].scores[game] = {
                e: player.scores.e,
                d1: player.scores.d1,
                penalty: player.scores.penalty,
                total: player.scores.total,
              };

              // Calculate totalAllAround based on the event category


              aggregatedPlayers[uniqueId].totalAllAround += player.scores.total;
            });
          }
        });

        const sortedPlayers = Object.values(aggregatedPlayers).sort((a, b) => b.totalAllAround - a.totalAllAround);
        setAllPlayers(sortedPlayers);

        await updateEventWithScores(sortedPlayers);
      } else {
        console.error('No players or sports found');
      }
    } catch (error) {
      console.error('Error fetching players:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateEventWithScores = async (players) => {
    try {
      // Format the data to match the event schema
      const updatedEventData = {
        ...event,
        allaroundScore: players.map(player => ({
          totalAllAround: player.totalAllAround,
        })),
      };

      await axios.put(`${API_URL}/api/events/${eventId}`, updatedEventData);
      console.log('Event updated successfully');
    } catch (error) {
      console.error('Error updating event:', error);
    }
  };

  const handleBack = () => {
      navigate(`/live/${eventId}`);
  };

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: 'all-sports-scores',
    onAfterPrint: () => alert('PDF export successful'),
  });

  if (loading || userLoading) {
    return <Spinner />;
  }


//   const enabledGames = event ? Object.keys(event.sports).filter(game => event.sports[game]) : [];
const vaultEvents = ['vault1Men', 'vault2Men', 'vault1Women', 'vault2Women'];
const enabledGames = event ? Object.keys(event.sports).filter(game => event.sports[game] && vaultEvents.includes(game)) : [];

  return (
    <Box bg={"gray.200"} style={{ padding: '20px', minHeight: '100vh' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <Button onClick={handleBack} style={{ padding: '10px 20px' }}>Back</Button>
        {/* <Button onClick={fetchAllPlayers}>Refresh</Button> */}
        {/* <Button onClick={generatePDF} style={{ padding: '10px 20px', border: 'none' }} bgGradient="linear(to-r, yellow.400, yellow.500, yellow.600)">Export to PDF</Button> */}
      </div>
      
      <div ref={componentPDF} style={{ width: '100%', margin: 'auto', overflowX: 'auto' }}>
        <Box>
        <Heading size="lg" bgClip="text" bgGradient="linear(to-r, yellow.500, yellow.600, yellow.700)" style={{ textAlign: 'center' }}>{event.competitionLevel === "state"? "State Level Gymnastics Competition": event.competitionLevel === "district"? "District Level Gymnastics Competition": event.competitionLevel === "club"? "Club Level Gymnastics Competition": event.competitionLevel === "school" ? "School Level Gymnastics Competition": event.competitionLevel === "individual"? "Individual Level Gymnastics Competition" : event.competitionLevel === "national"? "National Level Gymnastics Competition": event.competitionLevel}</Heading>
          <Heading size="md" style={{ color: 'black', textAlign: 'center' }}>{event.eventName}</Heading>
          <Heading size="md" style={{ color: 'black', textAlign: 'center' }}>Vault Final</Heading>
          <Text textAlign={"center"} color={"black"}>Date: {new Date(event.dateTime).toLocaleString()}</Text>
        </Box>
        {allPlayers.length > 0 ? (
            <Box
            overflowX="auto"
            width="100%"
            style={{ WebkitOverflowScrolling: 'touch' }}
          >
          <Table
          // variant="striped"
          width="90%"
          margin="auto"
          borderRadius="10px"
          // bg="#ffbf00"
          bg="gray.900"
          color="white"
          fontSize={"12px"}
          fontFamily={"sans-serif"}
          
          // colorScheme="gray"
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.25) 0px 15px 25px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
            position: 'relative', // Make sure the table itself is positioned relative to handle any absolute positioning within it
            overflow: 'hidden' // Ensure any overflow from rows is hidden
          }}
        >
            <Thead>
                <Tr>
                {/* <Th style={{ fontSize:"12px", padding: '10px', border: '1px solid #ddd', color: 'white', width: '10%' }}>SR</Th> */}
                <Th style={{ padding: '10px', border: '1px solid #ddd', textAlign:"center", color: 'white',}}>Name</Th>
                {/* <Th style={{ padding: '10px', border: '1px solid #ddd', textAlign:"center", color: 'white', }}>Athlete Code</Th> */}
                <Th style={{ padding: '10px', border: '1px solid #ddd', textAlign:"center", color: 'white', }}>Team/Dist</Th>
                {enabledGames.map((game) => (
                  <Th key={game} style={{ padding: '10px', border: '1px solid #ddd', color: 'white' }}>
                    {game == "vault2Men"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={VT}/><Text fontSize={"8px"} textAlign={"center"}>Vault 2</Text></Box>: game == "vault1Men"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={VT}/><Text fontSize={"8px"} textAlign={"center"}>Vault 1</Text></Box>:game == "vault2Women"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={VT}/><Text fontSize={"8px"} textAlign={"center"}>Vault 2</Text></Box>:game == "vault1Women"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={VT}/><Text fontSize={"8px"} textAlign={"center"}>Vault 1</Text></Box>:game == "vaultWomen"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={VT}/><Text fontSize={"8px"} textAlign={"center"}>Vault</Text></Box>: game == "floor"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={FX}/><Text fontSize={"8px"} textAlign={"center"}>Floor</Text></Box>: game == "pommel_horse"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={PH}/><Text fontSize={"8px"} textAlign={"center"}>Pommel Horse</Text></Box>: game == "rings"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={SR}/><Text fontSize={"8px"} textAlign={"center"}>Rings</Text></Box>: game == "vaultMen"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={VT}/><Text fontSize={"8px"} textAlign={"center"}>Vault</Text></Box>: game == "parallel_bars"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={PB}/><Text fontSize={"8px"} textAlign={"center"}>Parallel Bars</Text></Box>: game == "horizontal_bar"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={HB}/><Text fontSize={"8px"} textAlign={"center"}>Horizontal Bar</Text></Box>: game == "uneven_bars"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={UB}/><Text fontSize={"8px"} textAlign={"center"}>Uneven Bars</Text></Box>: game == "balance_beam"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={BB}/><Text fontSize={"8px"} textAlign={"center"}>Balance Beam</Text></Box>: game == "floor_exercise"? <Box borderRadius={"10px"} backgroundColor={"gray.900"}><Img w={"40px"} m={"auto"} src={FX}/><Text fontSize={"8px"} textAlign={"center"}>Floor</Text></Box>: game}
                  </Th>
                ))}
                <Th style={{ padding: '10px', border: '1px solid #ddd', textAlign:"center", color: 'white',  }}>Vault Total</Th>
                <Th style={{ padding: '10px', border: '1px solid #ddd', textAlign:"center", color: 'white', }}>RANK</Th>
              </Tr>
            </Thead>
            <Tbody>
              {allPlayers.map((player, index) => (
                <Tr key={player._id}  style={{ position: 'relative', overflow: 'hidden' , backgroundColor: index % 2 === 1 ? 'gray' : 'white',
                color: index % 2 === 1 ? 'white' : 'black' }} >
                  {/* <Td style={{ padding: '10px', border: '1px solid #ddd' }}>{index + 1}</Td> */}
                  <Td style={{ padding: '10px', border: '1px solid #ddd' }}>{player.name}</Td>
                  {/* <Td style={{ padding: '10px', border: '1px solid #ddd' }}>{player.athleteCode}</Td> */}
                  <Td style={{ padding: '10px', border: '1px solid #ddd' , textAlign:"center"}}>{player.teamName || 'N/A'}</Td>
                  {enabledGames.map((game) => (
                    <Td key={game} style={{ padding: '10px', textAlign:"center", border: '1px solid #ddd' }}>
                      {player.scores[game] ? `${player.scores[game].total}` : 'N/A'}
                    </Td>
                  ))}
                  <Td style={{ padding: '10px', textAlign:"center", border: '1px solid #ddd' }}>{(player.totalAllAround/2).toFixed(2)}</Td>
                  <Td style={{ padding: '10px', textAlign:"center", border: '1px solid #ddd' }}>{index + 1}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          </Box>
        ) : (
          <Text>No players data available</Text>
        )}
      </div>
    </Box>
  );
};

export default VaultFinal;
